export function condensed(num, precision = 1, options = {}) {
  const {forceZeroDecimal = false} = options;

  function format(amount) {
    let formatted = withPrecision(amount, precision, {noRound: true});
    if (!forceZeroDecimal && precision === 1) {
      formatted = Number(formatted);
    }
    return formatted;
  }

  if (num == null) {
    /* eslint-disable consistent-return */
    return;
  }

  const isNegative = num < 0;
  const number = Math.abs(num);

  let formattedValue;
  const rangeGroup = getNumberSuffix(number);

  switch (rangeGroup) {
    case 'b':
      formattedValue = `${format(number / 1000000000)}b`;
      break;
    case 'm':
      formattedValue = `${format(number / 1000000)}m`;
      break;
    case 'k':
      formattedValue = `${format(number / 1000)}k`;
      break;
    default:
      formattedValue = withDelimiter(format(number));
  }

  // Make sure to use Unicode U+2212 for minus and sign and NOT hyphen, for a11y reasons
  if (isNegative) {
    return `−${formattedValue}`;
  }

  return formattedValue;
}

export function getNumberSuffix(number) {
  if (number > 999999999) {
    return 'b';
  } else if (number > 999999) {
    return 'm';
  } else if (number > 999) {
    return 'k';
  }
  return '';
}

export function percentage(percent = 0, precision) {
  const per = Math.abs(percent);
  let accuracy = precision;

  if (accuracy == null) {
    accuracy = per < 1 && per !== 0 ? 1 : 0;
  }

  return `${withDelimiter(withPrecision(per, accuracy), ',')}%`;
}

export function withPrecision(number, precision = null, options = {}) {
  const {noRound = false} = options;

  if (precision === null) {
    return number;
  }

  if (noRound) {
    // do not round number
    // toFixed does this by default
    let regex;

    if (precision === 0) {
      regex = new RegExp('\\d+');
    } else {
      regex = new RegExp(`\\d+\\.(\\d{0,${precision}})`);
    }

    const match = number.toString().match(regex);

    if (match) {
      let numMatch = match[0];
      const decimals = match[1];
      if (decimals && decimals.length < precision) {
        // precision is bigger than captured decimals
        // add zeros
        const zerosToAdd = precision - decimals.length;
        for (let i = 0; i < zerosToAdd; i++) {
          numMatch += '0';
        }
      }
      return numMatch;
    }
  }

  return Number(number).toFixed(precision);
}

export function withDelimiter(number, delimiter = ',') {
  if (number == null) {
    return '';
  }

  const split = number.toString().split('.');
  split[0] = split[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${delimiter}`);
  return split.join('.');
}

export function formatCurrency(num, precision = 0, currencyCode = 'USD') {
  if (num == null) {
    return null;
  }

  if (num < 0) {
    return `−$${withDelimiter(
      withPrecision(Math.abs(num), precision)
    )} ${currencyCode}`;
  }

  return `$${withDelimiter(withPrecision(num, precision))} ${currencyCode}`;
}
